import type { ReactNode } from 'react';
import {
  Platform,
  ScrollView,
  View,
  type StyleProp,
  type ViewStyle,
} from 'react-native';

/**
 * Horizontal scroller that actually pans under touch on mobile WEB.
 *
 * RN-web's ScrollView routes touches through the responder system and
 * the gesture never reaches the browser's native panning — verified in
 * Wave 61 by dispatching a real touch drag against the My Home quick
 * toolbar: scrollLeft stayed at 0 despite overflow-x:auto. On web we
 * therefore render a plain flex-row View with CSS overflow scrolling
 * (zero JS in the gesture path); native keeps the real ScrollView.
 */
export function HScroll({
  children,
  style,
  contentStyle,
}: {
  children: ReactNode;
  style?: StyleProp<ViewStyle>;
  contentStyle?: StyleProp<ViewStyle>;
}) {
  if (Platform.OS === 'web') {
    return (
      <View
        style={[
          style,
          // scrollbarWidth is web-only; RNW passes it through.
          { overflow: 'scroll', scrollbarWidth: 'none' } as ViewStyle,
        ]}>
        <View style={[{ flexDirection: 'row' }, contentStyle]}>{children}</View>
      </View>
    );
  }
  return (
    <ScrollView
      horizontal
      showsHorizontalScrollIndicator={false}
      style={style}
      contentContainerStyle={contentStyle}>
      {children}
    </ScrollView>
  );
}
